<template lang="pug">
div
    el-dialog#modal-editar-territorio-vinculado(
        width='723px',
        :visible.sync='mostrar',
        :before-close='fechar',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        close='fechar'
    )
        span(slot='title')
            h1.font-weight-bold.modal-title
                i(class='mdi mdi-alert-circle warning')
                span {{ $t('mensagens.territorio.modalTerritorioEmContrato.edicaoTerritorioEmContrato') }}

        #corpo
            h3 {{ $t('mensagens.territorio.modalTerritorioEmContrato.territorioPossuiContratosVinculados') }}

        div(slot='footer')
            .buttons
                BaseButton(size='large', @click='fechar')
                    | {{ $t('mensagens.comuns.voltar') }}
</template>
        
<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalExisteContratoVinculado',
    components: {
        BaseButton
    },
    emits: ['fechar'],
    props: {
        mostrar: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {};
    },

    methods: {
        fechar() {
            this.$emit('fechar');
        }
    }
};
</script>
        
<style lang="scss">
#modal-editar-territorio-vinculado {
    border-radius: 5px;

    .el-dialog__header {
        background-color: #e9e9e9;
        padding-bottom: 20px;
    }

    .modal-title {
      padding-bottom: 15px;
    }

    .modal-title span {
        margin-left: 10px;
    }

    .el-dialog__body {
        padding: 30px 20px 30px;

        .inline {
            .el-form-item__content {
                text-align: end;
            }
        }

        h3 {
            font-size: 16px;
            margin-top: 10px;
        }
    }

    .el-dialog__footer {
        .buttons {
            display: flex;
            justify-content: space-between;
        }
    }

}
</style>
